import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { CMPS_WIDGET_OPTIONS } from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { TeamCoachingPopup } from './team-coaching-details.widget.model';

const WEB_FORMS_JOURNAL_URL = '/Journal/JournalSelectionCriteria.aspx';

@Component({
    selector: 'cmps-widget-team-coaching-details',
    templateUrl: './team-coaching-details.widget.component.html',
})
export class TeamCoachingDetailsWidgetComponent implements OnInit {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: TeamCoachingPopup;

    constructor(
        private readonly _router: Router,
        @Optional() @Inject(CMPS_WIDGET_OPTIONS) private readonly _options: any,
        public activeModal: NgbActiveModal,
        private readonly _service: LegacyWidgetService,
    ) {}

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .teamCoachingPopup(this._options.performerType)
            // eslint-disable-next-line no-return-assign, @typescript-eslint/consistent-type-assertions
            .subscribe(
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (data) => (this.data = <TeamCoachingPopup>data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    goToJournal(): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._router.navigate(['internal', 'webform'], {
            queryParams: { relativeUrl: WEB_FORMS_JOURNAL_URL },
        });
        this.activeModal.close();
    }
}
